import * as React from 'react'
import { Text } from '@doordash/design-language'
import { SectionContainer, ContentText } from '../../StyleComponents'
import { BulletList, BulletListItem, ImageContainer } from '../../styles'
import { i18nKeys } from 'translationTypes'
import i18n from '../../../../../i18n'

export const ImpairedDrivingSection: React.FC<{
  image: React.ReactElement
}> = ({ image }) => {
  return (
    <SectionContainer>
      <ImageContainer>{image}</ImageContainer>
      <Text styles={Text.Styles.Bold32}>
        {i18n.t(
          i18nKeys.safetyCourse_motorcycle_step3__online_safety_course__impaired_driving
        )}
      </Text>

      <Text styles={Text.Styles.Body2} weight={Text.Weights.Bold}>
        {i18n.t(
          i18nKeys.safetyCourse_motorcycle_step3__impaired_driving__alcohol_and_other_substances
        )}
      </Text>
      <ContentText>
        {i18n.t(
          i18nKeys.safetyCourse_motorcycle_step3__impaired_driving__drunk_driving_is_a_major_cause_of_death_on_australian
        )}
      </ContentText>
      <BulletList>
        {[
          i18nKeys.safetyCourse_motorcycle_step3__impaired_driving__slows_your_brain_functions_reducing_your_ability_to_react_or,
          i18nKeys.safetyCourse_motorcycle_step3__impaired_driving__reduces_your_ability_to_judge_speeds_and_your_distance_from,
          i18nKeys.safetyCourse_motorcycle_step3__impaired_driving__gives_you_false_confidence_and_you_may_take_greater_risk,
          i18nKeys.safetyCourse_motorcycle_step3__impaired_driving__makes_it_harder_to_do_more_than_one_thing_at,
          i18nKeys.safetyCourse_motorcycle_step3__impaired_driving__alcohol_will_also_remain_in_your_system_for_a_long,
        ].map((key, i) => (
          <BulletListItem mb={'XSmall'} key={i}>
            <ContentText>{i18n.t(key)}</ContentText>
          </BulletListItem>
        ))}
      </BulletList>
      <ContentText>
        {i18n.t(
          i18nKeys.safetyCourse_motorcycle_step3__impaired_driving__both_illegal_and_prescription_drugs_can_increase_your_crash_risk000
        )}
      </ContentText>
      <ContentText>
        {i18n.t(
          i18nKeys.safetyCourse_motorcycle_step3__impaired_driving__some_medicines_can_also_affect_your_ability_to_drive_safely001
        )}
      </ContentText>

      <Text styles={Text.Styles.Body2} weight={Text.Weights.Bold}>
        {i18n.t(
          i18nKeys.safetyCourse_motorcycle_step3__impaired_driving__fatigue
        )}
      </Text>
      <ContentText>
        {i18n.t(
          i18nKeys.safetyCourse_motorcycle_step3__impaired_driving__driving_while_fatigued_or_impaired_can_have_significant_consequences_as000
        )}
      </ContentText>
      <ContentText>
        {i18n.t(
          i18nKeys.safetyCourse_motorcycle_step3__impaired_driving__before_you_ride_ask_yourself001
        )}
      </ContentText>
      <BulletList>
        {[
          i18nKeys.safetyCourse_motorcycle_step3__impaired_driving__am_i_okay_to_drive,
          i18nKeys.safetyCourse_motorcycle_step3__impaired_driving__have_i_had_enough_rest,
          i18nKeys.safetyCourse_motorcycle_step3__impaired_driving__can_i_make_safe_decisions,
        ].map((key, i) => (
          <BulletListItem mb={'XSmall'} key={i}>
            <ContentText>{i18n.t(key)}</ContentText>
          </BulletListItem>
        ))}
      </BulletList>
      <ContentText>
        {i18n.t(
          i18nKeys.safetyCourse_motorcycle_step3__impaired_driving__tips_for_managing_fatigue
        )}
      </ContentText>
      <BulletList>
        {[
          i18nKeys.safetyCourse_motorcycle_step3__impaired_driving__avoid_driving_when_you_would_normally_sleep,
          i18nKeys.safetyCourse_motorcycle_step3__impaired_driving__know_when_its_time_to_rest_and_take_regular_breaks,
          i18nKeys.safetyCourse_motorcycle_step3__impaired_driving__take_a_nap_20_minutes_works_best,
        ].map((key, i) => (
          <BulletListItem mb={'XSmall'} key={i}>
            <ContentText>{i18n.t(key)}</ContentText>
          </BulletListItem>
        ))}
      </BulletList>
      <ContentText>
        {i18n.t(
          i18nKeys.safetyCourse_motorcycle_step3__impaired_driving__consider_the_potential_impacts_of_fatigue_before_you_begin_dashing000
        )}
      </ContentText>
      <ContentText>
        {i18n.t(
          i18nKeys.safetyCourse_motorcycle_step3__impaired_driving__driving_tired_is_not_only_a_problem_on_long_drives001
        )}
      </ContentText>
    </SectionContainer>
  )
}
